export const TESTING_APP_ORIGIN = process.env.REACT_APP_TESTING_APP_ORIGIN;
export const PARENT_APP_ORIGIN = process.env.REACT_APP_PARENT_APP_ORIGIN;
